import { mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

export const containerCss = {
  display: "flex",
  flexDirection: "row",
  gap: 24,
  width: "100%",
  [breakpoint.upTo("xs")]: {
    flexDirection: "column",
    gap: 10,
  },
};

export const comboboxCss = {
  width: "100%",
  ul: {
    zIndex: 1,
    maxWidth: "100%",
    width: "100%",
    textAlign: "left",
    left: 0,
  },
};
